export const defaultScopeId = "v3.workflowTasks";

export const SUBSCRIBE = "TASK/SUBSCRIBE";
export const UNSUBSCRIBE = "TASK/UNSUBSCRIBE";
export const LOAD_REQUESTED = "TASK/LOAD_REQUESTED";
export const LOAD_SUCCEEDED = "TASK/LOAD_SUCCEEDED";
export const LOAD_FAILED = "TASK/LOAD_FAILED";
export const LOAD_SINGLE_REQUESTED = "TASK/LOAD_SINGLE_REQUESTED";
export const LOAD_SINGLE_SUCCEEDED = "TASK/LOAD_SINGLE_SUCCEEDED";
export const LOAD_SINGLE_FAILED = "TASK/LOAD_SINGLE_FAILED";
export const UPDATE_READ_REQUESTED = "TASK/UPDATE_READ_REQUESTED";
export const UPDATE_READ_SUCCEEDED = "TASK/UPDATE_READ_SUCCEEDED";
export const UPDATE_READ_FAILED = "TASK/UPDATE_READ_FAILED";

const findById = taskId => ({ id }) =>  taskId === id;

// eslint-disable-next-line max-statements
export default (state = {
    errors: [],
    hasInitialData: false,
    loading: false,
    subscriptions: 0,
    tasks: [],
    updating: 0,
}, { type, data }) => {
    switch (type) {
    case SUBSCRIBE: {
        ++state.subscriptions;
        state.loading = true;
        return state;
    }
    case UNSUBSCRIBE: {
        --state.subscriptions;
        return state;
    }
    case LOAD_REQUESTED: {
        state.loading = true;
        return state;
    }
    case LOAD_SUCCEEDED: {
        state.tasks = data;
        state.loading = false;
        state.hasInitialData = true;
        return state;
    }
    case LOAD_FAILED: {
        state.errors.push({ ...data, type });
        state.loading = false;
        return state;
    }

    case LOAD_SINGLE_REQUESTED: {
        ++state.loading;
        const { taskId } = data;
        const task = state.tasks.find(
            findById(taskId)
        );
        if (task) {
            task.loading = true;
        }
        return state;
    }
    case LOAD_SINGLE_FAILED: {
        --state.loading;
        const { taskId, ...error } = data;
        const task = state.tasks.find(
            findById(taskId)
        );
        if (task) {
            task.loading = false;
            task.error = error;
        }
        state.errors.push({ type, taskId, ...error });
        return state;
    }
    case LOAD_SINGLE_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        const { id, ...properties } = data;
        const task = state.tasks.find(findById(id));
        if (task) {
            Object.assign(
                task,
                properties,
                {
                    loading: false,
                }
            );
        } else {
            state.tasks.push(data);
        }
        return state;
    }
    case UPDATE_READ_REQUESTED: {
        data.forEach(({ id: taskId }) => {
            const task = state.tasks.find(findById(taskId));
            if (task){
                task.updating = true;
            }
            ++state.updating;
        });
        return state;
    }
    case UPDATE_READ_SUCCEEDED: {
        const { data: { updateManyTasksRead: tasks } } = data;
        tasks.forEach(({ id, ...properties }) => {
            Object.assign(state.tasks.find(findById(id)) || {}, properties, {
                updating: false
            });
            --state.updating;
        });
        return state;
    }
    case UPDATE_READ_FAILED: {
        state.errors.push({ ...data, type });
        const { tasks } = data;
        tasks.forEach(({ id }) => {
            const task = state.tasks.find(findById(id));
            if (task){
                task.updating = false;
            }
            --state.updating;
        });
        return state;
    }
    default: return state;
    }
};

export const subscribeTasks = data => ({ type: SUBSCRIBE, data });
export const unsubscribeTasks = data => ({ type: UNSUBSCRIBE, data });

export const requestTasksLoad = (data, resolve, reject) => ({ type: LOAD_REQUESTED, data, resolve, reject });
export const succeedTasksLoad = data => ({ type: LOAD_SUCCEEDED, data });
export const failTasksLoad = data => ({ type: LOAD_FAILED, data });

export const requestTaskLoad = (data, resolve, reject) => ({ type: LOAD_SINGLE_REQUESTED, data, resolve, reject });
export const succeedTaskLoad = data => ({ type: LOAD_SINGLE_SUCCEEDED, data });
export const failTaskLoad = data => ({ type: LOAD_SINGLE_FAILED, data });

export const requestTasksUpdateRead = (data, resolve, reject) => ({ type: UPDATE_READ_REQUESTED, data, resolve, reject });
export const succeedTasksUpdateRead = data => ({ type: UPDATE_READ_SUCCEEDED, data });
export const failTasksUpdateRead = data => ({ type: UPDATE_READ_FAILED, data });
